var config = {
    columns: [
        '__checkbox:id',  // display checkbox in each row and associate with <id> field
        {
            title: 'Année',
            name: 'annee',
            sortField: 'date_valeur',
        },
        {
            title: 'Numero',
            name: 'id_extrait',
        },
        {
            title: 'De',
            name: '__slot:compte_de',
            sortField: 'compteDe.proprietaire.nom',
        },
        {
            title: 'Vers',
            name: '__slot:compte_vers',
            sortField: 'compteVers.proprietaire.nom',
        },
        {
            title: 'Date',
            name: 'date_valeur',
            sortField: 'date_valeur',
            callback: 'formatDate|DD/MM/YYYY'
        },
        {
            title: 'Montant',
            name: 'montant',
            sortField: 'montant',
            callback: 'formatMontant'
        },
        {
            title: 'Communication',
            name: 'communication'
        },
        {
            title: 'Ventilation',
            name: 'reste_ventilation',
            callback: 'ventilation'
        },
        {
            name: '__slot:actions',   // <----
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
        }
    ],
    itemActions: [
        {name: 'view-item', label: '', icon: 'glyphicon glyphicon-zoom-in', class: 'btn btn-default'},
        {name: 'ventiler-item', label: '', icon: 'glyphicon glyphicon-random', class: 'btn btn-warning'},
        {name: 'compte-attente-item', label: '', icon: 'glyphicon glyphicon-flash', class: 'btn btn-primary', callback: "dontShowIfVentilee"}
    ],
    sortOrder: [{field: 'date_valeur', direction: 'desc'}]
}

export default config



// WEBPACK FOOTER //
// ./src/components/VueTable/configs/vueTableOperation.js